export type {CheckboxProps} from './Checkbox.type';

export {CheckboxElement} from './Checkbox';
